// 機能訓練レポート・月選択画面.
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as AuthActions from '../actions/Auth';
import * as MoffAPIActions from '../actions/MoffAPI';
import * as LiterallyReport from '../actions/LiterallyReport';
import * as BarthelIndex from '../actions/BarthelIndex';
import * as HDSR from '../actions/HDSR';
import * as HeaderActions from '../actions/Header';
import LiterallyReportSelectMonth from '../components/LiterallyReportSelectMonth';

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth,
    moffAPI: state.moffAPI,
    literallyReport: state.literallyReport,
    barthelIndex: state.barthelIndex,
    hdsr: state.hdsr,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    authActions: bindActionCreators(AuthActions, dispatch),
    moffAPIActions: bindActionCreators(MoffAPIActions, dispatch),
    literallyReportActions: bindActionCreators(LiterallyReport, dispatch),
    barthelIndexActions: bindActionCreators(BarthelIndex, dispatch),
    hdsrActions: bindActionCreators(HDSR, dispatch),
    headerActions: bindActionCreators(HeaderActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiterallyReportSelectMonth as any);



// WEBPACK FOOTER //
// ./src/containers/LiterallyReportSelectMonth.tsx